/**
 * DataTable type
 * @param {object} headers - Headers
 */
export default function (headers) {
	this.items = []
	this.count = -1
	this.headers = headers
}
